/** @format */

import React, { PureComponent } from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import adescomStyle from '../../assets/jss/adescom/adescomStyle';
import Box from '@material-ui/core/Box';
import I18n from '../Translate/I18n';
import { Icon, SvgIcon, TableSortLabel, Typography } from '@material-ui/core';
import { ArrowDropDown } from '@material-ui/icons';
import compose from 'recompose/compose';
import GridContainer from '../Grid/GridContainer';
import SearchCellInputText from '../Search/SearchCellInputText';
import Filter from '../../interfaces/forms/Filter';
import EsDateTime from '../../modules/es/EsDateTime';
import HeaderBooleanCheckBoxSelectList from '../../views/lib/search/listTableHeader/HeaderBooleanCheckBoxSelectList';
import HeaderCheckBoxSimpleList from '../../views/lib/search/listTableHeader/HeaderCheckBoxSimpleList';
import { FilterHelper } from '../../views/lib/search/FilterHelper';
import HeaderPlatformReseller from '../../views/lib/search/listTableHeader/HeaderPlatformReseller';
import HeaderMvnoBlockList from '../../views/lib/search/listTableHeader/HeaderMvnoBlockList';
import HeaderApiOerationState from '../../views/lib/search/listTableHeader/HeaderApiOerationState';
import EsDateTimeFromTo from '../../modules/es/EsDateTimeFromTo';
import HeaderPlkStatus from '../../views/lib/search/listTableHeader/HeaderPlkStatus';
import PlatformResellerInterface from '../../interfaces/platform/PlatformResellerInterface';
import { connect } from 'react-redux';
import { FilterListReducerFieldName } from '../../modules/filter/FilterListReducers';
import Grid from '@material-ui/core/Grid';
import { ReactComponent as ArrowDown } from '../../assets/themes/OPL/img/icons/ArrowDown.svg';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
const _ = require('underscore');

export interface ExtraHeaderValuesInterface {
    value: number;
    i18string: string;
    addToList: boolean;
}

interface TableHeaderContentCellProps {
    classes: any;
    fontSize?: number | null;
    fontWeight?: number | null;
    textAlign?: string | null;
    title: string;
    titleVariables: undefined | null | object;
    breakLine?: boolean;
    autoComplete?: string;
    setStringToUpper?: boolean;

    dateAfter?: boolean;
    dateBefore?: boolean;
    beforeSetToMax?: boolean | null;
    afterSetToMin?: boolean | null;
    dateFromTo?: boolean;
    dateFormat?: string;
    appendAutomaticTimeToBeforeAfterDate?: boolean;

    onlyFilter?: boolean;
    showSort?: boolean;

    updateOrderList(orders: Array<Filter>): void;

    updateFilterList(filters: Array<Filter>): void;

    updateFilterOnEmtyList(filedName: string): string | Array<number> | Array<string> | Array<boolean>;

    searchActionCallback(): void;

    sort?: Array<Filter> | null;
    filters?: Array<Filter> | null;
    fieldName?: string | null;
    sortFieldName?: string | null;
    defaultDirection?: Sort | null;
    searchFieldType?: 'string' | 'number' | 'email' | 'zip' | 'phone' | 'select' | 'date' | null;
    selectComponent?: string;
    rangeFlag?: boolean;
    elementList?: Array<object>;
    platformResellerList: Array<PlatformResellerInterface> | null;
    timeFormat?: boolean | string;
    dispatch: any;
    nullable?: boolean;
    extraValues?: Array<ExtraHeaderValuesInterface>;

    prependToSearchString?: string;
    prependCheckIfExists?: boolean;
    prependMaxLengthRequirement?: number;
    prependMinLengthRequirement?: number;
}

/**
 * @deprecated not use
 */
export interface RefElementList {
    name: string;
    ref: any;
}

interface TableHeaderContentCellState {
    direction: Sort;
    rangeFlag: boolean;
    notNull: boolean;
}

type Sort = 'asc' | 'desc';

class TableHeaderContentCell extends PureComponent<TableHeaderContentCellProps, TableHeaderContentCellState> {
    private filterHelper: FilterHelper;
    private elementRef: any;

    constructor(props: TableHeaderContentCellProps, context: TableHeaderContentCellState) {
        super(props, context);

        let rangeFlag = false;
        if (props.rangeFlag) {
            rangeFlag = props.rangeFlag;
        }

        this.state = {
            direction: 'asc',
            rangeFlag: rangeFlag,
            notNull: false,
        };
        this.filterHelper = new FilterHelper(this.props, this.state);
        this.elementRef = React.createRef();
    }

    onClickSort = (event: React.MouseEvent<unknown>): void => {
        const { direction } = this.state;
        const { sort } = this.props;
        const isDesc = direction === 'desc';
        if (sort === null) {
            return;
        }
        this.setState(
            {
                direction: isDesc ? 'asc' : 'desc',
            },
            (): void => this.props.updateOrderList(this.updateOrderList(direction))
        );
    };

    updateField = (fieldNameUpdate: string, value: string | Array<number> | Array<string> | Array<boolean>, items?: any): Array<Filter> | null => {
        const {
            updateFilterOnEmtyList,
            dispatch,
            title,
            titleVariables,
            elementList,
            prependToSearchString,
            prependMinLengthRequirement,
            prependMaxLengthRequirement,
            prependCheckIfExists,
        } = this.props;
        this.filterHelper = new FilterHelper(this.props, this.state);
        const rawValue = value;
        if (value && value.length === 0 && updateFilterOnEmtyList) {
            value = updateFilterOnEmtyList(fieldNameUpdate);
        }
        let prependRequired = false;
        if (prependToSearchString && typeof value === 'string') {
            if (
                prependMinLengthRequirement &&
                prependMaxLengthRequirement &&
                value.length >= prependMinLengthRequirement &&
                value.length <= prependMaxLengthRequirement
            ) {
                prependRequired = true;
            }
            if (!prependMinLengthRequirement && prependMaxLengthRequirement && value.length <= prependMaxLengthRequirement) {
                prependRequired = true;
            }
            if (!prependMinLengthRequirement && !prependMaxLengthRequirement) {
                prependRequired = true;
            }

            if (prependRequired) {
                if (prependCheckIfExists && !value.startsWith(prependToSearchString)) {
                    value = prependToSearchString + value;
                } else {
                    value = prependToSearchString + value;
                }
            }
        }

        let dateOverwrite = value;
        if ((fieldNameUpdate.includes('[before]') || fieldNameUpdate.includes('[after]')) && this.props.appendAutomaticTimeToBeforeAfterDate) {
            if (fieldNameUpdate.includes('[before]')) {
                dateOverwrite = dateOverwrite + ' 23:59:59';
            }
            if (fieldNameUpdate.includes('[after]')) {
                dateOverwrite = dateOverwrite + ' 00:00:00';
            }
        }

        dispatch({
            type: FilterListReducerFieldName.HEADER_FILTER_MANAGE,
            columnName: title,
            elementList: items ? items : elementList,
            headerFilterListElementName: fieldNameUpdate,
            headerFilterListElementHasValue: value.length !== 0 && value !== '',
            headerFilterListElementValue: value,
            headerFilterListElementRawValue: rawValue,
        });
        return this.filterHelper.updateField(fieldNameUpdate, dateOverwrite);
    };

    updateOrderList = (direction: string): Array<Filter> => {
        const { fieldName, sortFieldName } = this.props;
        const newOrder = new Array<Filter>();
        if (!fieldName) {
            return [];
        }
        let tmpSortFieldName = fieldName;
        if (sortFieldName) {
            tmpSortFieldName = sortFieldName;
        }
        newOrder.push({ name: tmpSortFieldName, value: direction });
        return newOrder;
    };

    updateFromSelectList = (fieldName: string, value: Array<number> | Array<string> | Array<boolean> | string, items?: any): void => {
        this.updateField(fieldName, value, items);
    };

    getValidComponent = (name?: string): object | null => {
        const { fieldName, elementList, platformResellerList, extraValues, nullable } = this.props;
        if (!name) {
            return null;
        }
        switch (name) {
            case 'headerBooleanCheckBoxSelectList':
                return <HeaderBooleanCheckBoxSelectList fieldName={fieldName} handleChange={this.updateFromSelectList} extraValues={extraValues} />;
            case 'headerCheckBoxSimpleList':
                if (elementList) {
                    return (
                        <HeaderCheckBoxSimpleList
                            fieldName={fieldName}
                            handleChange={this.updateFromSelectList}
                            elementList={elementList}
                            extraValues={extraValues}
                            nullable={nullable}
                        />
                    );
                }
                return null;
            case 'headerPlatformReseller':
                return <HeaderPlatformReseller fieldName={fieldName} handleChange={this.updateFromSelectList} extraValues={extraValues} />;
            case 'headerMvnoBlockList':
                if (platformResellerList) {
                    return (
                        <HeaderMvnoBlockList
                            fieldName={fieldName}
                            handleChange={this.updateFromSelectList}
                            platformResellerList={platformResellerList}
                            extraValues={extraValues}
                            nullable={nullable}
                        />
                    );
                }
                return null;
            case 'headerApiOperationStateHelper':
                return <HeaderApiOerationState fieldName={fieldName} handleChange={this.updateFromSelectList} extraValues={extraValues} />;
            case 'headerPlkStatus':
                return <HeaderPlkStatus fieldName={fieldName} handleChange={this.updateFromSelectList} extraValues={extraValues} />;
            default:
                return null;
        }
    };

    render():
        | React.ReactElement<any, string | React.JSXElementConstructor<any>>
        | string
        | number
        | {}
        | React.ReactNodeArray
        | React.ReactPortal
        | boolean
        | null
        | undefined {
        const {
            title,
            titleVariables,
            fontSize,
            fontWeight,
            textAlign,
            showSort,
            sort,
            fieldName,
            searchFieldType,
            selectComponent,
            onlyFilter,
            dateAfter,
            dateBefore,
            dateFromTo,
            autoComplete,
            dateFormat,
            breakLine,
            timeFormat,
            searchActionCallback,
            beforeSetToMax,
            afterSetToMin,
            setStringToUpper,
            nullable,
        } = this.props;

        let isActive = false;
        let isDesc: Sort = 'desc';
        if (showSort) {
            isActive = _.some(sort, (item: Filter): boolean => {
                return item.name === fieldName;
            });
            isDesc = this.state.direction === 'desc' ? 'asc' : 'desc';
        }

        return (
            <Typography component="div">
                <Box textAlign={textAlign ? textAlign : 'center'} fontWeight={fontWeight ? fontWeight : 800} fontSize={fontSize ? fontSize : 12}>
                    {showSort && (
                        <GridContainer>
                            <Grid item xs={12}>
                                {!onlyFilter && (
                                    <TableSortLabel
                                        active={isActive}
                                        IconComponent={ExpandMoreIcon}
                                        direction={isDesc}
                                        onClick={this.onClickSort}
                                        style={{ float: 'left' }}
                                    >
                                        {titleVariables &&
                                            <I18n trans={title} valueObject={titleVariables} />
                                        }
                                        {!titleVariables &&
                                            <I18n trans={title} />
                                        }
                                    </TableSortLabel>
                                )}
                                {onlyFilter && (
                                    <div style={{ float: 'left' }}>
                                        {titleVariables &&
                                            <I18n trans={title} valueObject={titleVariables} />
                                        }
                                        {!titleVariables &&
                                            <I18n trans={title} />
                                        }
                                    </div>
                                )}
                            </Grid>
                            <Grid item xs={12}>
                                {searchFieldType && searchFieldType !== 'select' && searchFieldType !== 'date' && (
                                    <SearchCellInputText
                                        setStringToUpper={setStringToUpper}
                                        searchActionCallback={searchActionCallback}
                                        inputType={searchFieldType}
                                        fieldName={fieldName}
                                        updateCallback={this.updateField}
                                        nullable={nullable}
                                        autoComplete={autoComplete}
                                    />
                                )}
                                {searchFieldType && searchFieldType === 'select' && this.getValidComponent(selectComponent)}
                                {searchFieldType && searchFieldType === 'date' && (
                                    <React.Fragment>
                                        {dateFromTo && !dateBefore && !dateAfter && (
                                            <EsDateTimeFromTo
                                                searchActionCallback={searchActionCallback}
                                                timeFormat={timeFormat}
                                                breakLine={breakLine}
                                                fieldName={fieldName}
                                                dateFormat={dateFormat}
                                                beforeSetToMax={beforeSetToMax}
                                                afterSetToMin={afterSetToMin}
                                                callback={this.updateField}
                                                nullable={nullable}
                                                autoComplete={autoComplete}
                                            />
                                        )}
                                        {!dateFromTo && dateBefore && !dateAfter && (
                                            <EsDateTime
                                                searchActionCallback={searchActionCallback}
                                                timeFormat={timeFormat}
                                                fieldName={fieldName + '[before]'}
                                                callback={this.updateField}
                                                nullable={nullable}
                                                autoComplete={autoComplete}
                                            />
                                        )}
                                        {!dateFromTo && !dateBefore && dateAfter && (
                                            <EsDateTime
                                                searchActionCallback={searchActionCallback}
                                                timeFormat={timeFormat}
                                                fieldName={fieldName + '[after]'}
                                                callback={this.updateField}
                                                nullable={nullable}
                                                autoComplete={autoComplete}
                                            />
                                        )}
                                        {!dateFromTo && !dateBefore && !dateAfter && (
                                            <EsDateTime
                                                searchActionCallback={searchActionCallback}
                                                timeFormat={timeFormat}
                                                breakLine={breakLine}
                                                fieldName={fieldName}
                                                dateFormat={dateFormat}
                                                callback={this.updateField}
                                                nullable={nullable}
                                                autoComplete={autoComplete}
                                            />
                                        )}
                                    </React.Fragment>
                                )}
                            </Grid>
                        </GridContainer>
                    )}
                    {!showSort && (
                        <div>
                            {titleVariables &&
                                <I18n trans={title} valueObject={titleVariables} />
                            }
                            {!titleVariables &&
                                <I18n trans={title} />
                            }
                        </div>
                    )}
                </Box>
            </Typography>
        );
    }
}

export default compose<any, any>(connect(), withStyles(adescomStyle))(TableHeaderContentCell);
